module.exports = {
  BASE_URL: "https://staging-app.jala.tech",
  API_URL: "https://staging-app.jala.tech/api",
  OAUTH2_URL: "https://staging-app.jala.tech/oauth",
  JALA_CHAT_GPT_URL: "https://serverless.jala.tech/chat-gpt-dev",
  CLIENT_ID: "10",
  CLIENT_SECRET: "Dmq39fRF0Vz6Xy5j0xea9IVx2YVEOH5vKeSU04yQ",

  MIXPANEL_TOKEN: "af876456d82502962e4a7f117be7c5ef",
  INTERCOM_APP_ID: "dxwnmoek",
  INTERCOM_API_KEY: "android_sdk-5fb63bbb06a05a7d78e26631a54f13bd83648e2d",
  INTERCOM_SECRET_KEY: "HZYjg9bWfmVIv0x1DQmNGIR_BuX7jWy35R0LW9WH",
  INTERCOM_SECRET_KEY_WEB: "RPikvinQd6P_MisZ4et5HeOiFkauGGxz_LTLVOYa",
  POSTHOG_API_KEY: "phc_cmm6kSb9JAU8KkIlpiWzsdEhDvBerFfkdEtck81XPQ6",

  SENTRY_DSN: "https://6977e9ee8390451da7eaec7065075dd8@o133133.ingest.sentry.io/5672613",
  SENTRY_DSN_WEB: "https://2dd666289b74438081f79597c1e316d0@o133133.ingest.sentry.io/4504504052416512",
  APPCENTER_DEPLOYMENT_KEY_ANDROID: "HvuwSWCt8ZImHHLJkh-KNAGWFus18HmS06K59",
  APPCENTER_DEPLOYMENT_KEY_IOS: "wG4CCzksMJJ3WQBFyqyV194Vk9k4NyLFR85xt",
  APPCENTER_DISABLED: false,

  UXCAM_APP_KEY: 'kfsdkyh6af7go63',

  AIRTABLE_BASE_ID: "appR8Vd9vSfrKdR6H",
  AIRTABLE_API_KEY: "key91MASmNzKfzBBj",
  AIRTABLE_FIELD: "tbl0CMwdqfptdxU4q",
  AIRTABLE_LEADERBOARD: "tbl5LToNq1Aj4iKYp"
}
